import { Box, Card, RadioButton } from '@factorialco/deprecated-design-system'

interface ExpirationTimeSelectorProps {
  onClick: (value: number) => void
  value: number
  label: string
  selectedValue: number
  loading: boolean
}

export const ExpirationTimeSelector = ({
  onClick,
  value,
  label,
  selectedValue,
  loading,
}: ExpirationTimeSelectorProps) => {
  return (
    <Box width="fit-content">
      <Card
        onClick={() => {
          if (loading || selectedValue === value) return
          onClick(value)
        }}
      >
        <Card.Title
          action={
            <Box paddingLeft="s16">
              <RadioButton
                value={value.toString()}
                checked={selectedValue === value}
                onChange={() => {}}
              />
            </Box>
          }
        >
          {label}
        </Card.Title>
      </Card>
    </Box>
  )
}
